import { render, staticRenderFns } from "./MainDetractors.vue?vue&type=template&id=5b2b02eb&scoped=true"
import script from "./MainDetractors.vue?vue&type=script&lang=ts"
export * from "./MainDetractors.vue?vue&type=script&lang=ts"
import style0 from "./MainDetractors.vue?vue&type=style&index=0&id=5b2b02eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b02eb",
  null
  
)

export default component.exports